module.exports = __webpack_public_path__ + "img/purple.141f0501.jpg";